import documentTypeCodes from "constants/documentTypeIds";
import OfferType from "constants/offerType";
import { emptyArray } from "constants/emptyConst";

export const getIsContractModification = offerTypeId => {
  return offerTypeId === OfferType.restructuring.id || offerTypeId === OfferType.cession.id;
};

export const getDocumentSubtypes = (state, documentTypeId) => {
  if (!state.dictionaries.offerTypes[documentTypeId]) return emptyArray;

  return state.dictionaries.offerTypes[documentTypeId] && state.dictionaries.offerTypes[documentTypeId].offerTypes;
};

export const getRiskAnalysisTypes = state => {
  if (!state.dictionaries.riskAnalysisTypes.isLoaded) return emptyArray;
  return state.dictionaries.riskAnalysisTypes.items;
};

export const getPriceTypes = state => {
  if (!state.dictionaries.priceTypes.isLoaded) return emptyArray;
  return state.dictionaries.priceTypes.items;
};

export const getIsFacilityFrame = documentTypeId => {
  return documentTypeId === documentTypeCodes.FacilityFrameOffer;
};

export const getCurrencies = state =>
  state.dictionaries.currencies.isLoaded ? state.dictionaries.currencies.items : emptyArray;

export const getIsFinancingOffer = documentTypeId => {
  return documentTypeId === documentTypeCodes.Offer;
};
